import { forwardRef } from 'react';
import { Box, Button, Divider } from '@mui/material';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';

const CustomListbox = forwardRef(function CustomListbox(props, ref) {
  const { children, onSelectAll, onClearAll, totalProfiles, events, selectAllLabel, ...other } = props;

  const defaultSelectAllLabel = totalProfiles
    ? `Select All ${totalProfiles} profiles`
    : events
      ? `Select All ${events.length} events`
      : 'Select All';

  return (
    <ul ref={ref} {...other}>
      {(onSelectAll || onClearAll) && (
        <>
          <Box px={2} py={1} display="flex" gap={2}>
            {onSelectAll && (
              <Button
                size="small"
                sx={{ color: '#6366f1', textTransform: 'none' }}
                startIcon={<TaskAltOutlinedIcon />}
                onMouseDown={(e) => e.preventDefault()}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelectAll();
                }}
              >
                {selectAllLabel ?? defaultSelectAllLabel}
              </Button>
            )}

            {onClearAll && (
              <Button
                size="small"
                sx={{ color: '#aaa', textTransform: 'none' }}
                startIcon={<DisabledByDefaultOutlinedIcon />}
                onMouseDown={(e) => e.preventDefault()}
                onClick={(e) => {
                  e.stopPropagation();
                  onClearAll();
                }}
              >
                Clear All
              </Button>
            )}
          </Box>

          <Divider sx={{ backgroundColor: '#333' }} />
        </>
      )}

      {children}
    </ul>
  );
});

export default CustomListbox;
